import {
  INICIA_ANO_LETIVO,
  NOVO_ANO_LETIVO,
  BUSCA_ANO_LETIVO_EDICAO,
  CANCELA_EDICAO,
  INICIO_ANO_LETIVO_SUCESSO,
  SALVA_ANO_LETIVO_SUCESSO,
  REMOVE_ANO_LETIVO_SUCESSO,
  BUSCA_ANO_LETIVO_EDICAO_SUCESSO,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  ALTERACAO_CHECK,
  APLICA_FILTRO,
  LISTA_ANO_LETIVO,
  LISTA_ANO_LETIVO_SUCESSO,
  LIMPAR_ANO_LETIVO,
  LISTA_TIPOS_ETAPAS_ANO_LETIVO_SUCESSO,
  LISTA_ESCOLAS_ANO_LETIVO_SUCESSO,
  ANOLETIVO_TIPOETAPA_MODAL_OPEN,
  ANOLETIVO_TIPOETAPA_MODAL_CLOSE,
  ANOLETIVO_TIPOETAPA_MODAL_ATUALIZA_CAMPO,
  ANOLETIVO_TIPOETAPA_SALVAR_SUCESSO,
  ANOLETIVO_TIPOETAPA_ATUALIZAR_SUCESSO,
  APLICA_FILTRO_ANO_LETIVO,
} from "constants/ActionTypes";
import moment from 'moment';

const INIT_STATE = {
  colunasGrid: [
    { titulo: 'Ano', propriedadeApi: 'ano', alinhamento: 'left' },
    { titulo: 'Escola', propriedadeApi: 'escolaNome', alinhamento: 'left' },
    { titulo: 'Tipo de Etapa', propriedadeApi: 'etapaNome', alinhamento: 'left' },
    { titulo: 'Status', propriedadeApi: 'status', alinhamento: 'left' },
    { titulo: 'Ações', propriedadeApi: 'acoes', alinhamento: 'center', acoes: true }
  ],
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  anoLetivoCarregado: null,
  id: 0,
  escolaId: null,
  ano: '',
  status: 'Criado',
  tipoEtapaId: null,
  copiarProfessores: false,
  copiarServidores: false,
  periodosEtapas: [],
  listaEscolas: [],
  listaTiposEtapas: [],
  escolaFiltro: 0,
  anoFiltro: '',
  statusFiltro: '',
  tipoEtapaModalOpen: false,
  tipoEtapaModalData: { id: null, descricao: '', qtdEtapas: 0 }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_ANO_LETIVO: {
      return { ...state, loader: true };
    }
    case APLICA_FILTRO_ANO_LETIVO: {
      const texto = action.payload || '';
      return {
        ...state,
        textoFiltro: texto
      }
    }
    case CANCELA_EDICAO: {
      return { ...state, edicao: false };
    }
    case NOVO_ANO_LETIVO: {
      return {
        ...state,
        edicao: true,
        id: 0,
        ano: '',
        escolaId: null,
        status: 'Criado',
        tipoEtapaId: null,
        copiarProfessores: false,
        copiarServidores: false,
        periodosEtapas: []
      };
    }
    case BUSCA_ANO_LETIVO_EDICAO: {
      return { ...state, loader: true };
    }
    case INICIO_ANO_LETIVO_SUCESSO: {
      const retorno = action.payload || {};
      const lista = Array.isArray(retorno.anosLetivos) ? retorno.anosLetivos : [];
      const filtrada = state.textoFiltro && state.textoFiltro.length >= 3
        ? lista.filter(r => String(r.escolaNome || r.escola || '').toLowerCase().includes(state.textoFiltro.toLowerCase()) || String(r.ano || '').includes(state.textoFiltro))
        : lista;
      return { ...state, loader: false, carregandoLista: false, listGrid: lista, listGridComFiltro: filtrada };
    }
    case SALVA_ANO_LETIVO_SUCESSO: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: false };
    }
    case REMOVE_ANO_LETIVO_SUCESSO: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: false };
    }
    case BUSCA_ANO_LETIVO_EDICAO_SUCESSO: {
      const base = action.payload || {};
      const periodosRaw = Array.isArray(base.periodosEtapas) ? base.periodosEtapas : (Array.isArray(base.periodos) ? base.periodos : []);
      const periodos = periodosRaw.map((p, idx) => {
        const diRaw = p.dataInicio || p.DataInicio || p.dataInicial || p.DataInicial || '';
        const dfRaw = p.dataFim || p.DataFim || p.dataFinal || p.DataFinal || '';
        const fmt = (v) => {
          if (!v) return '';
          if (typeof v === 'string') {
            const m1 = moment(v, 'DD/MM/YYYY', true);
            if (m1.isValid()) return m1.format('DD/MM/YYYY');
            const m2 = moment(v);
            return m2.isValid() ? m2.format('DD/MM/YYYY') : '';
          }
          const m3 = moment(v);
          return m3.isValid() ? m3.format('DD/MM/YYYY') : '';
        };
        return {
          id: p.id || p.Id || 0,
          etapaIndex: p.etapaIndex || p.EtapaIndex || idx + 1,
          dataInicio: fmt(diRaw),
          dataFim: fmt(dfRaw),
          diasLetivos: p.diasLetivos || p.DiasLetivos || 0
        };
      });
      return {
        ...state,
        loader: false,
        edicao: true,
        id: base.id || base.Id || 0,
        escolaId: base.escolaId || base.EscolaId || base.idEscola || base.IdEscola || null,
        ano: base.ano || base.Ano || '',
        status: base.status || base.Status || 'Criado',
        tipoEtapaId: base.tipoEtapaId || base.TipoEtapaId || base.etapaAnoLetivoId || base.EtapaAnoLetivoId || null,
        copiarProfessores: !!(base.copiarProfessores || base.CopiarProfessores),
        copiarServidores: !!(base.copiarServidores || base.CopiarServidores),
        periodosEtapas: periodos
      };
    }
    case LISTA_ANO_LETIVO: {
      return { ...state, loader: true };
    }
    case LISTA_ANO_LETIVO_SUCESSO: {
      const retorno = action.payload || {};
      const lista = Array.isArray(retorno.anosLetivos) ? retorno.anosLetivos : [];
      const filtrada = state.textoFiltro && state.textoFiltro.length >= 3
        ? lista.filter(r => String(r.escolaNome || r.escola || '').toLowerCase().includes(state.textoFiltro.toLowerCase()) || String(r.ano || '').includes(state.textoFiltro))
        : lista;
      return { ...state, loader: false, carregandoLista: false, listGrid: lista, listGridComFiltro: filtrada };
    }
    case LIMPAR_ANO_LETIVO: {
      return { ...state, textoFiltro: '', escolaFiltro: 0, anoFiltro: '', statusFiltro: '' };
    }
    case HIDE_MESSAGE: {
      return { ...state, alertMessage: '', showMessageSuccess: false, showMessageError: false, loader: false };
    }
    case ON_HIDE_LOADER: {
      return { ...state, loader: false };
    }
    case ON_SHOW_LOADER: {
      return { ...state, loader: true };
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageError: true, edicao: false };
    }
    case SHOW_MESSAGE: {
      return { ...state, alertMessage: action.payload, showMessageError: true, loader: false };
    }
    case ANOLETIVO_TIPOETAPA_MODAL_OPEN: {
      const dados = action.payload || {};
      const valor = {
        id: dados.id || null,
        descricao: dados.descricao || dados.title || '',
        qtdEtapas: dados.qtdEtapas != null ? Number(dados.qtdEtapas) : 0
      };
      return { ...state, tipoEtapaModalOpen: true, tipoEtapaModalData: valor };
    }
    case ANOLETIVO_TIPOETAPA_MODAL_CLOSE: {
      return { ...state, tipoEtapaModalOpen: false };
    }
    case ANOLETIVO_TIPOETAPA_MODAL_ATUALIZA_CAMPO: {
      const nome = action.payload?.nome;
      const valor = action.payload?.valor;
      const dados = { ...(state.tipoEtapaModalData || {}) };
      dados[nome] = nome === 'qtdEtapas' ? Number(valor || 0) : valor;
      return { ...state, tipoEtapaModalData: dados };
    }
    case ALTERACAO_CAMPO: {
      const nome = action.payload?.target?.name;
      const valor = action.payload?.target?.value;
      if (typeof nome === 'string') {
        const m = nome.match(/^periodosEtapas\[(\d+)\]\.(\w+)$/);
        if (m) {
          const idx = Number(m[1]);
          const prop = m[2];
          const periodos = Array.isArray(state.periodosEtapas) ? state.periodosEtapas : [];
          const atualizados = periodos.map((p, i) => i === idx ? { ...p, [prop]: valor } : p);
          return { ...state, periodosEtapas: atualizados };
        }
      }
      return { ...state, [nome]: valor };
    }
    case ALTERACAO_COMBO: {
      const valorBruto = action.payload.valor;
      const valorNormalizado = (valorBruto && typeof valorBruto === 'object')
        ? (valorBruto.id !== undefined ? valorBruto.id : (valorBruto.value !== undefined ? valorBruto.value : valorBruto))
        : valorBruto;
      const nomeRaw = action.payload.nomeCombo;
      const nome = Array.isArray(nomeRaw) ? nomeRaw[0] : nomeRaw;
      let next = { ...state, [nome]: valorNormalizado };
      if (nome === 'tipoEtapaId') {
        const tipos = Array.isArray(state.listaTiposEtapas) ? state.listaTiposEtapas : [];
        const tipoSel = tipos.find(t => Number(t.id) === Number(valorNormalizado));
        const qtd = tipoSel && (tipoSel.qtdEtapas !== undefined) ? Number(tipoSel.qtdEtapas) : 0;
        const periodos = qtd > 0 ? Array(qtd).fill(0).map((_, idx) => ({ etapaIndex: idx + 1, dataInicio: '', dataFim: '', diasLetivos: 0 })) : [];
        next = { ...next, periodosEtapas: periodos };
      }
      if (nome === 'escolaId') {
        next = { ...next, tipoEtapaId: null, periodosEtapas: [] };
      }
      return next;
    }
    case ALTERACAO_CHECK: {
      const nome = Array.isArray(action.payload?.nomeCheck) ? action.payload.nomeCheck[0] : action.payload?.nomeCheck;
      const valor = action.payload?.valor;
      return { ...state, [nome]: valor };
    }
    case ALTERACAO_DATEPICKER: {
      const nome = action.payload?.name;
      const valor = action.payload?.date;
      if (typeof nome === 'string') {
        const m = nome.match(/^periodosEtapas\[(\d+)\]\.(\w+)$/);
        if (m) {
          const idx = Number(m[1]);
          const prop = m[2];
          const periodos = Array.isArray(state.periodosEtapas) ? state.periodosEtapas : [];
          const atualizados = periodos.map((p, i) => i === idx ? { ...p, [prop]: valor } : p);
          return { ...state, periodosEtapas: atualizados };
        }
      }
      return { ...state, [nome]: valor };
    }
    case LISTA_TIPOS_ETAPAS_ANO_LETIVO_SUCESSO: {
      const tiposRaw = action.payload?.tipos || action.payload || [];
      const listaTiposEtapas = Array.isArray(tiposRaw)
        ? tiposRaw.map(t => ({
            id: t.id || t.Id || 0,
            title: t.nome || t.Nome || t.nm_tipo || t.descricao || t.Descricao || '',
            qtdEtapas: (
              t.numEtapas != null ? t.numEtapas :
              t.NumEtapas != null ? t.NumEtapas :
              t.num_etapas != null ? t.num_etapas :
              t.qtdEtapas != null ? t.qtdEtapas :
              t.QtdEtapas != null ? t.QtdEtapas : 0
            )
          }))
        : [];
      let periodosEtapas = state.periodosEtapas;
      let tipoEtapaId = state.tipoEtapaId;
      if (tipoEtapaId) {
        const tipoSel = listaTiposEtapas.find(t => Number(t.id) === Number(tipoEtapaId));
        if (!tipoSel) {
          tipoEtapaId = null;
          periodosEtapas = [];
        } else {
          const desejado = Number(tipoSel.qtdEtapas || 0);
          const atual = Array.isArray(periodosEtapas) ? periodosEtapas : [];
          const atualLen = atual.length;
          if (desejado !== atualLen) {
            if (desejado < atualLen) {
              periodosEtapas = atual.slice(0, desejado).map((p, idx) => ({ ...p, etapaIndex: idx + 1 }));
            } else {
              const adicionais = Array(desejado - atualLen).fill(0).map((_, i) => ({ etapaIndex: atualLen + i + 1, dataInicio: '', dataFim: '', diasLetivos: 0 }));
              periodosEtapas = [...atual.map((p, idx) => ({ ...p, etapaIndex: idx + 1 })), ...adicionais];
            }
          }
        }
      }
      return { ...state, listaTiposEtapas, periodosEtapas, tipoEtapaId };
    }
    case LISTA_ESCOLAS_ANO_LETIVO_SUCESSO: {
      const escolasRaw = action.payload?.escolas || action.payload || [];
      const listaEscolas = Array.isArray(escolasRaw)
        ? escolasRaw.map(e => ({ id: e.id || e.Id || 0, title: e.nome || e.Nome || e.descricao || e.Descricao || e.titulo || e.Titulo || '' }))
        : [];
      return { ...state, listaEscolas };
    }
    case ANOLETIVO_TIPOETAPA_SALVAR_SUCESSO: {
      return { ...state, alertMessage: action.payload, showMessageSuccess: true, tipoEtapaModalOpen: false };
    }
    case ANOLETIVO_TIPOETAPA_ATUALIZAR_SUCESSO: {
      return { ...state, alertMessage: action.payload, showMessageSuccess: true, tipoEtapaModalOpen: false };
    }
    default:
      return state;
  }
}
